/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useState } from 'react';
import AiManagementDatetimePicker from 'components/atoms/ai_management_datetime_picker';
import CommentInput from 'components/molecules/comment_input';
import { BiddingUpdate } from 'services/ai_management_bidding_updates';
import { Container } from './styles';

const TITLE_MAX = 150;

interface AiManagementUpdateNewProps {
  onClose: () => void;
  onSave: (update: Omit<BiddingUpdate, 'id'>) => void;
}

const AiManagementUpdateNew: React.FC<AiManagementUpdateNewProps> = ({ onClose, onSave }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');
  const [description, setDescription] = useState('');
  const [files, setFiles] = useState<File[]>([]);
  const [notes, setNotes] = useState<string[]>([]);

  const addFiles = (list: FileList | null) => {
    if (!list?.length) return;
    setFiles((current) => [...current, ...Array.from(list)]);
  };

  const removeFile = (index: number) =>
    setFiles((current) => current.filter((_, position) => position !== index));

  const handleSave = () => {
    const trimmed = title.trim();
    if (!trimmed) return;

    onSave({
      category: 'edital_anexo',
      status: null,
      title: trimmed,
      description: description.trim() || null,
      messages: [],
      author: null,
      is_new: true,
      created_at: date ? `${date}T00:00:00` : new Date().toISOString(),
      attachments: files.map((file, index) => ({
        id: index,
        filename: file.name,
        url: '#',
        created_at: null,
      })),
      from_client: true,
    });
  };

  return (
    <Container className="flex-shrink-0 border-left bg-white d-flex flex-column">
      <div className="d-flex align-items-center justify-content-between px-4 pt-4 pb-3">
        <h4 className="mb-0">Adicionar atualização</h4>
        <button
          type="button"
          className="btn btn-link text-dark p-0 d-flex align-items-center"
          aria-label="Fechar"
          onClick={onClose}
        >
          <i className="material-icons">close</i>
        </button>
      </div>

      <div className="update-new-body flex-grow-1 px-4 pb-4">
        <div className="form-row">
          <div className="form-group col-md-8">
            <label htmlFor="new-update-title">Título</label>
            <input
              id="new-update-title"
              type="text"
              className="form-control"
              maxLength={TITLE_MAX}
              value={title}
              onChange={(event) => setTitle(event.target.value)}
            />
          </div>
          <div className="form-group col-md-4">
            <label htmlFor="new-update-date">Data</label>
            <AiManagementDatetimePicker
              id="new-update-date"
              value={date}
              onChange={setDate}
              withTime={false}
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="new-update-description">Descrição</label>
          <textarea
            id="new-update-description"
            className="form-control"
            rows={4}
            placeholder="Digite uma descrição para a atualização"
            value={description}
            onChange={(event) => setDescription(event.target.value)}
          />
        </div>

        <div className="update-section-title">Anexos</div>
        <button
          type="button"
          className="update-dropzone d-flex align-items-center justify-content-center w-100 px-3 py-4"
          onClick={() => fileInputRef.current?.click()}
        >
          <i className="material-icons mr-2">file_upload</i>
          Faça o upload do seu arquivo aqui
        </button>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          className="d-none"
          aria-label="Anexos da atualização"
          onChange={(event) => addFiles(event.target.files)}
        />

        {files.map((file, index) => (
          <div
            key={`${file.name}-${file.lastModified}`}
            className="update-file d-flex align-items-center justify-content-between border-bottom py-2"
          >
            <span className="text-truncate mr-2">{file.name}</span>
            <button
              type="button"
              className="btn btn-link text-danger p-0 d-flex align-items-center"
              aria-label={`Remover ${file.name}`}
              onClick={() => removeFile(index)}
            >
              <i className="material-icons">delete_outline</i>
            </button>
          </div>
        ))}

        <div className="update-section-title">Anotações</div>
        {notes.map((note) => (
          <div key={note} className="update-file border-bottom py-2">
            {note}
          </div>
        ))}
        <CommentInput
          isLoading={false}
          createComment={(note) => setNotes((current) => [...current, note])}
          commentSource="biddings"
        />
      </div>

      <div className="update-new-footer d-flex align-items-center justify-content-end border-top px-4 py-3">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSave}
          disabled={!title.trim()}
        >
          Salvar atualização
        </button>
      </div>
    </Container>
  );
};

export default AiManagementUpdateNew;
